import React from "react";
import { useTranslation } from "react-i18next";

// Images & Icons
import CCS_logo from "../../assets/consultings/CCS_logo_Cloudxier.png";

// Components
import Topic from "../components/Topic";
import Target from "../components/Target";
import WebinarList from "pages/ticketing/components/WebinarList";
import ThinkPartner from "../components/ThinkPartner";

function OurConsultation() {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="space-y-8 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-dark-blue app-animation-translate-start">
            ISA - CCS ThinkPartner
          </p>
          <div>
            <img
              src={CCS_logo}
              alt="main"
              className="object-cover object-center w-4/5 py-4 mx-auto sm:w-2/5 app-animation-scale-start"
            />
          </div>
          <div className="pt-3 pb-4 space-y-6 md:pt-6 md:pb-8">
            <p className="text-lg text-center md:text-xl xl:text-2xl app-animation-translate-start">
              <b>ISA Academy dan ISA Consulting</b> sebagai “your trustworthy
              partner in Sustainability” yang merupakan Lembaga Pendidikan dan
              Konsultan yang pertama-kali dan satu-satunya (saat ini) yang
              menyediakan Konsultasi Online dengan nama CCS - Combined Clinic
              for Sustainability Kami menyediakan teman diskusi yakni
              ThinkPartner, tentang masalah, tantangan, peluang, dan inspirasi
              di bidang ESG, CSR, Community Development, Entrepreneurship,
              Leadership, Social Entrepreneurship, Sustainability dan
              Leadership.
            </p>
          </div>
        </div>
      </section>
      <section className="bg-app-light-gray/5">
        <ThinkPartner />
      </section>
      <section>
        <Topic />
      </section>
      <section className="bg-app-light-gray/5">
        <Target />
      </section>
      <section>
        <div className="space-y-4 app-main-container">
          <p className="pt-3 pb-2 text-xl font-bold text-center md:pt-6 md:pb-4 md:text-2xl xl:text-4xl text-app-orange app-animation-translate-start">
            {t("ourConsultationTitle")}
          </p>
          <p className="text-xl font-bold text-center sm:text-2xl app-animation-translate-start">
            {t("webinarListSubTitle")}
          </p>

          <WebinarList />
        </div>
      </section>
    </div>
  );
}

export default OurConsultation;
